class ArticleShare extends HTMLElement {
  constructor() {
    super();
    this.setupClickHandlers();
  }
  setupClickHandlers() {
    const rawUrl = window.location.href;
    const fmtUrl = rawUrl.endsWith("/") ? rawUrl.replace(/\/$/, "") : rawUrl;
    const copyText = this.querySelector(".share-button__copy span");
    const url = encodeURIComponent(fmtUrl);
    const title = encodeURIComponent(window.document.title);
    const launchNewWindow = (link) => {
      const top = window.innerHeight / 2;
      const left = window.innerWidth / 1.75;
      window.open(
        link,
        "",
        `menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=300,width=600,top=${top},left=${left}`
      );
    };
    document.addEventListener(
      "click",
      function (event) {
        const $btn = event.target.closest("button");
        if ($btn && $btn.matches(".share-button__facebook")) {
          const fbUrl = `https://www.facebook.com/sharer/sharer.php?u=${url}`;
          launchNewWindow(fbUrl);
        }
        if ($btn && $btn.matches(".share-button__copy")) {
          navigator.clipboard.writeText(rawUrl).then(() => {
            copyText.innerText = "Copied";
            setTimeout(() => {
              copyText.innerText = "Copy";
            }, 1500);
          });
        }
        if ($btn.matches(".share-button__twitter")) {
          const twUrl = `https://twitter.com/intent/tweet?url=${url}%2F&text=${title}`;
          launchNewWindow(twUrl);
        }
      },
      false
    );
  }
}

customElements.define("article-share", ArticleShare);
